import { DEVICES } from '../const/devices.const';
import { detectMobileOrTablet } from './detectMobileTablet.util';

const device = detectMobileOrTablet();

export const isIntroEnabled =
	device === DEVICES.DESKTOP && process.env.ENABLE_INTRO === 'true';
